import { render } from "./meeting-edit-controls.vue?vue&type=template&id=4352cd4f"
import script from "./meeting-edit-controls.vue?vue&type=script&lang=js"
export * from "./meeting-edit-controls.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__